import { GetAppTrackerLabel } from "../ApplicationTrackerUtils";
import { ILicenceApplicationTrackerProps } from "./ILicenceApplicationTrackerProps";
import { TrackerCard } from "../TrackerCard";
import { MakeSubmissionOrObjection } from "../MakeSubmissionOrObjection";

export const NoTracker = ({
  licence,
  licenceProfile,
}: ILicenceApplicationTrackerProps) => {
  const bodyElements = (
    <MakeSubmissionOrObjection
      licence={licence}
      licenceProfile={licenceProfile}
    />
  );
  return (
    <TrackerCard
      title={GetAppTrackerLabel({ licence, licenceProfile })}
      content={bodyElements}
    />
  );
};
